import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import {
  CurrencyExchangeOutlined,
  DashboardOutlined,
  LocalShippingOutlined,
} from '@mui/icons-material';
import Container from '../../components/LandingPage/Container';
import { useNavigate } from 'react-router-dom';

/* eslint-disable react/prop-types */

const NewWayCard: React.FC<{ icon: React.ReactNode; title: string }> = ({ icon, title }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      width="100%"
      minHeight="44px"
      border="1px solid var(--acer-green)"
      padding="10px 9px"
    >
      <Typography
        display="flex"
        alignItems="center"
        gap="11px"
        fontSize="16px"
        fontWeight="500"
        lineHeight="24px"
        letterSpacing="0.15px"
        textAlign={{ xs: 'center', md: 'left' }}
        margin={{ xs: '0 auto', md: '0' }}
      >
        {icon}
        {title}
      </Typography>
    </Box>
  );
};

const NewWay: React.FC = () => {
  const navigate = useNavigate();
  const newWayCards = [
    {
      icon: <DashboardOutlined sx={{ color: 'var(--acer-green)' }} />,
      title: 'Sem estoque',
    },
    {
      icon: <LocalShippingOutlined sx={{ color: 'var(--acer-green)' }} />,
      title: 'Entrega direta da fábrica',
    },
    {
      icon: <CurrencyExchangeOutlined sx={{ color: 'var(--acer-green)' }} />,
      title: 'Comissão garantida',
    },
  ];

  return (
    <Container>
      <Box
        width="100%"
        display="flex"
        flexDirection={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
      >
        <Box
          display="flex"
          flexDirection="column"
          gap="19px"
          padding="54px 0"
          width={{ xs: '100%', md: '800px' }}
        >
          <Box display="flex" flexDirection="column" gap="11px">
            <Typography
              width={{ xs: '100%', md: '369px' }}
              fontSize="28px"
              fontWeight="400"
              lineHeight="36px"
              letterSpacing="0"
            >
              Uma nova forma de vender produtos Acer no Brasil
            </Typography>
            <Typography fontSize="16px" fontWeight="400" lineHeight="24px" letterSpacing="0.5px">
              Acer Empresas, em parceria com a CISP1, apresenta uma Plataforma de Distribuição
              Digital feita para revendas de tecnologia como a sua.
              <br />
              <br />O processo é simples: você indica o cliente, a Acer fatura direto para ele e sua
              empresa recebe comissão pela venda. Tudo digital, rápido e sem complicações logísticas
              ou fiscais.
            </Typography>
          </Box>
          <Box
            display="flex"
            margin={{ xs: '0 auto', md: '0' }}
            width={{ xs: '100%', md: '278px' }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={{
                width: '100%',
                fontWeight: '500',
                color: 'white',
                '&:hover': { backgroundColor: 'var(--acer-green)', color: 'white' },
              }}
              onClick={() => navigate('/register')}
            >
              <Typography>Quero ser revendedor</Typography>
            </Button>
          </Box>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          gap="12px"
          width={{ xs: '100%', md: '267px' }}
          justifyContent="center"
          margin={{ xs: '0 auto', md: '0' }}
          paddingBottom={{ xs: '24px', md: '0' }}
        >
          {newWayCards.map(newWayCard => (
            <NewWayCard key={newWayCard.title} icon={newWayCard.icon} title={newWayCard.title} />
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default NewWay;
